// extracted by mini-css-extract-plugin
export default {"icon":"PatientCard_icon__7Yw3s","different":"PatientCard_different__BnY9m","tooltip":"PatientCard_tooltip__LdZQH"};